import React from "react";

function MyMapComponent() {
  return (
    <div className="map">
  

      <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2574.3773389245034!2d23.971520976266213!3d49.81657277147805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473ae772fa672f9f%3A0xaa1a8c1c79af2d90!2z0LLRg9C70LjRhtGPINCa0YPQu9GM0YfQuNGG0YzQutC-0ZcsIDgsINCb0YzQstGW0LIsINCb0YzQstGW0LLRgdGM0LrQsCDQvtCx0LvQsNGB0YLRjCwgNzkwMDA!5e0!3m2!1suk!2sua!4v1695585570807!5m2!1suk!2sua"
        width="300"
        height="400"
        style={{ border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}

export default MyMapComponent;
